import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';
import { NgbDate, NgbDateNativeAdapter, NgbDatepickerI18n, NgbDatepickerModule, NgbDatepickerNavigateEvent, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { map, Observable } from 'rxjs';
import { CalendarDayData } from '../../models';
import { DashboardService } from '../../services';
import { CustomDatepickerI18n } from '../../shared';
import { CalendarDayComponent } from '../calendar-day';


/**
* Component for calendar in dashboard page.
*/
@Component({
	selector: 'dashboard-calendar',
	templateUrl: './dashboard-calendar.component.html',
	providers: [
		NgbDateNativeAdapter,
		{ provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }
	],
	imports: [
		AsyncPipe,
		NgbDatepickerModule,
		CalendarDayComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class DashboardCalendarComponent implements OnDestroy {

	private readonly dashbrdSrv = inject(DashboardService);
	private readonly dateAdapter = inject(NgbDateNativeAdapter);

	/**
	 * Get day template data. 
	 */
	dayTemplateData = (date: NgbDateStruct, current?: { year: number; month: number; }): Observable<CalendarDayData> => {
		return this.dashbrdSrv.strutEvents$.pipe(
			map(events => events?.filter(ev => NgbDate.from(date)?.equals(this.dateAdapter.fromModel(ev.date))) ?? []),
			map(events => ({ items: events } as CalendarDayData))
		);
	};

	/**
	 * Update strut events after calendar month change.
	 */
	changeMonth(ev: NgbDatepickerNavigateEvent): void {
		this.dashbrdSrv.loadEvents(ev.next);
	}

	/**
	 * Update current selected date.
	 */
	changeDate(ev: NgbDate): void {
		this.dashbrdSrv.updateDate(ev);
	}


	ngOnDestroy(): void {
		this.dashbrdSrv.reset();
	}
}
